export default "<div class=\"alert alert-info text-center\" *ngIf=\"conditionValue\">\n<p>Assessment are not available yet.</p>\n</div>"